export const SEL_TRACKING = "SEL_TRACKING";
export const ALL_TRACKINGS = "ALL_TRACKINGS";
export const ALL_TRACKINGS_COUNT = "ALL_TRACKINGS_COUNT";
export const ALL_TRACKING_UPDATES = "ALL_TRACKING_UPDATES";
export const ALL_TRACKING_STATUSES = "ALL_TRACKING_STATUSES";
export const ALL_TRACKING_UPDATES_COUNT = "ALL_TRACKING_UPDATES_COUNT";
